import base64url from "base64url";
import moment from "moment";
import { Constants } from "./constants.js";
import HafServices from "./UserFunctions";
import axios from "axios";
import OpenAI from "openai";

const options = {
  temperature: 0.1,
  max_tokens: 1000,
};



async function createChatCompletion(messages, options = {}) {
  console.log("messages=",messages,options);
  try {
    const response = await axios.post("/api/chat", {
      messages,
      options,
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
      }
    });
    console.log("response.data=",response.data)
    return response.data; // это уже массив choices
  } catch (error) {
    console.error("Frontend error:", error.response?.data || error.message);
    throw error;
  }
}


// async function createChatCompletion(messages, options = {}) {
//   console.log("messages=",messages,"options=",options)
//   const openai_api_key = await axios.get(`/api/return_openai_api_key`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
//     },
//   });
//   console.log("openai_api_key=", openai_api_key);
//   const openai = new OpenAI({
//     apiKey: openai_api_key.data.msg,
//     dangerouslyAllowBrowser: true,
//   });
//   const completion = await openai.chat.completions.create({
//     messages: messages,
//     model: options.model || process.env.REACT_APP_OPENAI_MODEL,
//   });
//   console.log(completion.choices[0]);
//   return completion.choices[0]
// }

//!========================================================================================
/*                                                                                      *
 *                             FUNCTION  createFileUploading                            *
 *                                                                                      */
//!========================================================================================

async function createFileUploading(CompanyId, filename, options = {}) {
  // You can also pass a `fetch` `Response`:
  //========================================================================================
  /*                                                                                      *
   *                                     LOAD API KEY                                     *
   *                                                                                      */
  //========================================================================================

  const openai_api_key = await axios.get(`/api/return_openai_api_key`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
    },
  });
  console.log("openai_api_key=", openai_api_key);
  const openai = new OpenAI({
    apiKey: openai_api_key.data.msg,
    dangerouslyAllowBrowser: true,
  });

  axios.post(`/api/downloadfile?id=${CompanyId}`,
    {
      id: CompanyId,
      filename: filename
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
      },
    }
  ).then(async (res) => {
    const fileName = filename;
    var binary = atob(res.data);
    var array = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    var blob = new Blob([array]);
    // window.saveAs(blob, fileName);

    const file = await openai.files.create({
      file: new File([blob], fileName),
      purpose: "assistants",
    });

    console.log(">>>>>file=",file);
    return res;
  });
}

// export { createChatCompletion, createFileUploading };

export { createFileUploading, createChatCompletion };
